import ShowMoreText from './ShowMoreText.js';
export { default } from './ShowMoreText.js';
//# sourceMappingURL=index.js.map
